import { useMemo } from 'react';
import type { PreviewData } from '../../../../store/types/template';
import {
  toPosterGenericInput,
  type PosterTemplateAttributes,
} from '../../pass-templates-new/utils/posterGenericInput';
import type { FeaturedActionsApiInput } from '../../pass-templates-new/utils/mapApiResponseToTemplateState';
import { buildPassEnhancedPreview } from '../utils/buildPassEnhancedPreview';

export const usePassEnhancedPreview = (
  templateAttributes: Record<string, unknown> | undefined,
  previewData: PreviewData | undefined,
  featuredActions: FeaturedActionsApiInput | null | undefined
): PreviewData | undefined => {
  const templateInput = useMemo(() => {
    const attributes = templateAttributes as
      | PosterTemplateAttributes
      | undefined;
    return attributes?.appleEnhancedDesign?.type === 'generic'
      ? toPosterGenericInput(attributes)
      : undefined;
  }, [templateAttributes]);

  return useMemo(
    () =>
      previewData
        ? {
            ...previewData,
            appleEnhanced: buildPassEnhancedPreview({
              templateAttributes: templateAttributes as PosterTemplateAttributes,
              templateInput,
              previewData,
              featuredActions,
            }),
          }
        : undefined,
    [templateAttributes, templateInput, previewData, featuredActions]
  );
};
